import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';
import { AppSettingsService } from './app-settings.service';
import { ClaimsService } from './claims.service';
import { MenuService } from './menu.service';
import { TokenService } from './token.service';

@Injectable()
export class Authorized implements CanActivate {

    constructor(private authService: AuthService,
        private claimsService: ClaimsService,
        private menuService: MenuService,
        private router: Router,
        private appSettingsService: AppSettingsService,
        private tokenService: TokenService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.isAuthorized() && !this.tokenService.isBearerTokenExpired() && this.menuService.hasRights(this.claimsService.getUserTypeId(), state.url)) {
            return true;
        }

        if (!this.authService.isAuthorized() || this.tokenService.isBearerTokenExpired()) {
            this.router.navigate([this.appSettingsService.AutoLogin, state.url]);
            return true;
        }

        this.router.navigate([this.appSettingsService.UnauthorizedPath]);
        return false;
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/auth-guard.service.ts